import { useCallback, useState } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useLocalVideoToggle() {
  const { room, localTracks, getLocalVideoTrack, removeLocalVideoTrack, onError } = useVideoContext();
  const videoTrack = localTracks.find(
    (t: any) => t.trackMediaType === 'video' && !(t as any).trackName?.includes?.('screen')
  );
  const [isPublishing, setIspublishing] = useState(false);

  const toggleVideoEnabled = useCallback(() => {
    if (isPublishing) return;
    // In call: unpublish + remove track (or acquire + publish)
    if (videoTrack && room) {
      room.client.unpublish([videoTrack]).then(() => removeLocalVideoTrack());
      return;
    }
    // Pre-join (no room yet): only toggle local preview — remove or create camera track
    if (videoTrack && !room) {
      removeLocalVideoTrack();
      return;
    }
    setIspublishing(true);
    getLocalVideoTrack()
      .then(track => {
        if (room) {
          return room.client.publish([track]).then(() => {});
        }
        return undefined;
      })
      .catch(onError)
      .finally(() => setIspublishing(false));
  }, [videoTrack, room, getLocalVideoTrack, isPublishing, onError, removeLocalVideoTrack]);

  return [!!videoTrack, toggleVideoEnabled] as const;
}
